/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetTreeMultilanguageQueryResponse } from '../../types/TelegramGeoControllerGetTreeMultilanguage.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetTreeMultilanguage } from '../../methods/telegramGeoGetTreeMultilanguage.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetTreeMultilanguageQueryKey = () => [{ url: '/api/telegram/geo/tree/multilanguage' }] as const;

export type TelegramGeoGetTreeMultilanguageQueryKey = ReturnType<typeof telegramGeoGetTreeMultilanguageQueryKey>;

export function telegramGeoGetTreeMultilanguageQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetTreeMultilanguageQueryKey();
  return queryOptions<
    TelegramGeoControllerGetTreeMultilanguageQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetTreeMultilanguageQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetTreeMultilanguage(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/tree/multilanguage}
 */
export function useTelegramGeoGetTreeMultilanguage<
  TData = TelegramGeoControllerGetTreeMultilanguageQueryResponse,
  TQueryData = TelegramGeoControllerGetTreeMultilanguageQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetTreeMultilanguageQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetTreeMultilanguageQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetTreeMultilanguageQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetTreeMultilanguageQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
